export class PageSort {
  constructor(public field?: string, public order?: string) {}
}

export class PageModel<T> {
  constructor(
    public content: T[] = [],
    public number: number = 0,
    public size: number = 10,
    public sort?: PageSort,
    public totalElements: number = 0,
    public totalPages?: number,
    public numberOfElements?: number
  ) {}
}
